<script setup lang="ts">
import { type HTMLAttributes, computed, ref } from 'vue'
import { ProgressIndicator, ProgressRoot, type ProgressRootProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = withDefaults(
  defineProps<
    ProgressRootProps & { class?: HTMLAttributes['class']; delta?: number; current: number }
  >(),
  {
    modelValue: 0
  }
)

const currentRef = ref()
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
const deltaOffset = computed(() => currentRef.value?.offsetWidth || 0)
</script>

<template>
  <div class="w-full relative">
    <ProgressRoot
      v-bind="delegatedProps"
      :class="
        cn(
          'relative min-h-[10px] max-h-[10px] w-full overflow-hidden rounded-full bg-rank-progress',
          props.class
        )
      "
    >
      <ProgressIndicator
        class="min-h-[10px] max-h-[10px] bg-highlight transition-all"
        :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
      />
    </ProgressRoot>
    <div
      ref="currentRef"
      class="bg-highlight absolute -top-[7px] text-sm font-semibold h-[22px] px-2 flex items-center justify-center rounded-[20px]"
      :style="`left: ${props.modelValue}%; transform: translateX(-50%)`"
    >
      {{ props.current }}
    </div>
    <div
      class="bg-rank-delta absolute right-0 -top-7 text-[11px] font-semibold h-[18px] px-2 flex items-center justify-center rounded-[20px]"
    >
      +{{ props.delta }}
    </div>
  </div>
</template>
